export default "__VITE_PUBLIC_ASSET__15060812__"